/** Grammar from the text (词语例释 / grammar box): short Russian explanation + examples. */
import type { Lesson } from '../../core/content.ts';
import { useTutor } from '../../state/tutor.tsx';
import { routes, useRouter } from '../../state/router.tsx';
import { Icon } from '../../ui/Icon.tsx';

export function GrammarStep({
  lesson,
  grammarIds,
  speechLang,
  onDone,
}: {
  lesson: Lesson;
  grammarIds: string[];
  speechLang: string;
  onDone: () => void;
}) {
  const { navigate } = useRouter();
  const { setDraft } = useTutor();
  const points = lesson.grammar.filter((g) => grammarIds.length === 0 || grammarIds.includes(g.id));

  return (
    <div className="stack stack--24">
      <p className="t-caps">Грамматика из текста</p>
      {points.map((g) => (
        <article key={g.id} className="card grammar">
          <h2 className="grammar__title han" lang={speechLang}>
            {g.title}
          </h2>
          {g.pattern && <p className="grammar__pattern han">{g.pattern}</p>}
          <p>{g.explanation_ru}</p>
          <ul className="grammar__examples" lang={speechLang}>
            {g.examples.map((e, i) => (
              <li key={i} className={e.fromTextSentenceId ? 'grammar__example--text' : undefined}>
                <span className="han">{e.zh ?? e.en}</span>
                <span className="t-meta">{e.ru}</span>
                {e.fromTextSentenceId && <span className="chip grammar__from-text">из текста</span>}
              </li>
            ))}
          </ul>
          {g.accuracyCheck && (
            <p className="grammar__check">
              <strong>{g.accuracyCheck.rule}</strong> Не <s>{g.accuracyCheck.wrong}</s>, а {g.accuracyCheck.right}
            </p>
          )}
          <button
            type="button"
            className="btn btn--text"
            onClick={() => {
              setDraft(`Объясни ещё раз «${g.title}» и дай два новых примера.`);
              navigate(routes.chat);
            }}
          >
            <Icon name="chat" size={18} /> Спросить учителя
          </button>
        </article>
      ))}
      <div className="lesson__footer">
        <button type="button" className="btn btn--primary btn--block" onClick={onDone}>
          Продолжить
        </button>
      </div>
    </div>
  );
}
